import React, { Component } from 'react'
import AppStore from '../store/AppStore'
import HomeAction from '../home/actions/HomeAction'
import Action from './actions/Action'
import Notif from './actions/Notif'
import { NOTIF } from './actions/constants/ActionConstants'
import UUID from 'uuid'

class ActionComponent extends Component {
	setAction(actions) {
		const comp = actions.map(action => {
                switch (action.type) {
                    case NOTIF:
                        return (
                            <Notif key={ `notif-${action.title}` } onClick ={ action.fn } icon={ action.icon } content={ action.content } title={action.title} color={ action.color } label={ action.label } notifs={ action.notifs }/>
                        )
                    default :
                        return (
                            <Action key={ UUID.v4() } onClick={ action.fn } icon={ action.icon } component={ action.component } title={action.title}/>
                        )
                }
			}
		)
		AppStore.dispatch(HomeAction.setAction(comp))
	}

	componentWillUnmount() {
		AppStore.dispatch(HomeAction.setAction([]))
	}

	render() {
		return null
	}
}

export default ActionComponent



// WEBPACK FOOTER //
// ./src/components/ActionComponent.js